module.exports = __webpack_public_path__ + "static/Chat_Ingles_desk-1ecb659ca7f96942d8c4e6fa37a21b3e.mp4";